import React, { Component } from 'react';
import { Image, View } from 'core';
import { getURL, cache, URL, CDN } from 'utils';
import * as actions from 'actions';

export class CachedImage extends Component {
  constructor(props) {
    super(props);
    const { upload, is_large } = props;
    const { file_id, user_id } = upload;
    this.state = {
      [`${user_id}${file_id}.s.jpg`]: this.getCDNUrl(upload, 's'),
      [`${user_id}${file_id}.l.jpg`]: is_large ? this.getCDNUrl(upload, 'l') : null
    };
  }

  componentDidMount() {
    this.is_mounted = true;
    this.qued && this.qued();
    this.qued = null;
  }

  componentWillUnmount() {
    this.is_mounted = false;
    this.qued = null;
  }

  componentDidUpdate(prevProps) {
    const pu = prevProps.upload;
    const u = this.props.upload;
    if (pu.user_id !== u.user_id || pu.file_id !== u.file_id) {
      const { file_id, user_id } = u;
      this.setState({
        [`${user_id}${file_id}.s.jpg`]: this.getCDNUrl(u, 's'),
        [`${user_id}${file_id}.l.jpg`]: this.props.is_large ? this.getCDNUrl(u, 'l') : null
      });
    }
  }

  setUploadState = (url, upload) => {
    const setState = () => {
      this.setState({ [`${upload.user_id}${upload.file_id}`]: url });
      this.qued = null;
    };
    // we are quing set state in case a url was returned before component mounted.
    this.is_mounted ? setState() : (this.qued = setState);
  };

  getURL = (upload, size) => this.state[`${upload.user_id}${upload.file_id}.${size}.jpg`];

  getCDNUrl = (upload, size) => {
    const { is_group } = this.props;
    const { file_id, user_id } = upload;
    const url = CDN.getURL({ user_id, file_id: `${file_id}.${size}.jpg`, is_group, default_avatar: file_id < 100, size, remote_url: true }, this.setUploadState);
    return url;
  };

  render() {
    const { upload, style, is_large, color, size } = this.props;
    const uri_s = this.getURL(upload, 's');
    const uri_l = this.getURL(upload, 'l');
    const blob_url = actions.uploader.getBlobURI(upload.file_id);
    if (blob_url) {
      return <Image source={{ uri: blob_url }} style={size} />;
    }
    if (is_large) {
      return (
        <View style={[size, { backgroundColor: color }, style]}>
          {uri_s ? <Image key={uri_s} source={{ uri: uri_s }} style={size} /> : null}
          {uri_l ? <Image key={uri_l} source={{ uri: uri_l }} style={[size, { position: 'absolute' }]} /> : null}
        </View>
      );
    }
    return <View style={[size, { backgroundColor: color }, style]}>{uri_s ? <Image key={uri_s} source={{ uri: uri_s }} style={size} /> : null}</View>;
  }
}



// WEBPACK FOOTER //
// ./src/components/core/cached_image.js